import React from 'react';
import { Button, Box, Typography, Stack } from '@mui/material';
import { ArrowForward, ExpandLess, ExpandMore } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import TypedValue from '../../TypedValue';

const ChannelTotalButton = ({ text, tabShown, onClick, disabled, value, count = null, hasTab = false, icon = null }) => {
    const theme = useTheme();

    const textColour = disabled
        ? theme.palette.text.secondary
        : tabShown
            ? '#FFF'
            : theme.palette.text.primary;

    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            sx={{ width: '100%' }}
            variant={tabShown ? 'contained' : 'outlined'}
            color={tabShown ? 'primary' : undefined}
        >
            <Stack>
                <Typography
                    variant="h4"
                // todo: fontsize string length dependent
                >
                    <TypedValue value={value} type="number" accuracy={0} />
                </Typography>
                <Stack
                    direction="row"
                    spacing={0.5}
                >
                    {icon}
                    <Typography
                        variant="caption"
                        color={textColour}
                        lineHeight={1.8}
                    >
                        from {count || ''} <Box component="span" sx={{ whiteSpace: 'pre' }}>{text}</Box> {!disabled ? hasTab ? tabShown ? <ExpandLess fontSize="inherit" /> : <ExpandMore fontSize="inherit" /> : <ArrowForward fontSize="inherit" /> : undefined}
                    </Typography>
                </Stack>
            </Stack>
        </Button>
    );
};

export default ChannelTotalButton;